import request from "@utils/request";

export function getHomeData(deptId) {
  return request.get("index/"+deptId, {}, { login: false });
}

export function getOfficialAccountList(deptId) {
  return request.get("officialAccountList/"+deptId, {}, { login: false });
}


export function getArticleList(q) {
  return request.get("/article/list/", q, { login: false });
}

export function getShare() {
  return request.get("/share", {}, { login: false });
}

export function getCityName(latitude,longitude) {
    const url = '/getAddressByLocation/' + latitude + '/' + longitude;
    return request.get(url, {}, { login: false });
}

export function getArticleDetails(id) {
  return request.get("/article/details/" + id, {}, { login: false });
}

export function getWechatConfig(deptId) {
  return request.get(
    "/wechat/config",
    { url: document.location.href, deptId: deptId },
    { login: false }
  );
}

export function wechatAuth(code, spread, deptId, login_type) {
  return request.get(
    "/wechat/auth",
    { code, spread, deptId, login_type },
    { login: false }
  );
}

export function getLogistics() {
  return request.get("/logistics", {}, { login: false });
}

/**
* 获取url后面的参数
*/
export function getRequest() {
  const url = location.search; //获取url中"?"符后的字串
  const theRequest = {};
  if(url.indexOf("?") !== -1) {
    const str = url.substr(1);
    const strs = str.split("&");
    for(let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
    }
  }
  return theRequest;
}
